import { defineComponent as _defineComponent } from 'vue'
import SolutionsCarouselSlideMobile from '~/components/sections/sliderSection/SolutionsCarouselSlideMobile.vue';
import { useSwiperElement } from '~/composables';

interface Props {
  slides?: any[];
}
interface Emits {
  (e: 'slide-change', data: number): void;
  (e: 'init', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsCarouselSliderMobile',
  props: {
    slides: { default: () => [] }
  },
  emits: ["slide-change", "init"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'slide-change', data: number): void;
  (e: 'init', data: any): void;
}), expose: any, slots: any, attrs: any }) {





const swiperOptions = {
  observer: true,
  slidesPerView: 1,
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
  on: {
    init: (swiper: any) => emit('init', swiper),
    activeIndexChange: (swiper: any) =>
      emit('slide-change', swiper.activeIndex),
  },
};

const swiperEl = useSwiperElement(swiperOptions);

return { __sfc: true,emit, swiperOptions, swiperEl, SolutionsCarouselSlideMobile }
}

})